var _defs, _clipPath, _linearGradient, _path, _defs2, _clipPath2, _linearGradient2, _path2, _defs3, _clipPath3, _linearGradient3, _path3, _defs4, _clipPath4, _linearGradient4, _path4, _defs5, _clipPath5, _linearGradient5, _path5, _defs6, _clipPath6, _linearGradient6, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDab = function SvgDab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 222 61.6",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dab_svg__a",
    d: "m34.2 7-.1.2c1.7.7 8.4 4.4 9.3 5.5-3.3.4-9.6 2.1-13.3 3.7v.6c3.9-.8 9.1-1.2 12.7-1.4-1.4 2.1-2.4 3.1-4.5 5.5l-.2.5c4.1-2.5 5.3-2.7 9.1-4.9 1.4 2.1 1.8 7 1.8 10.9a37.2 37.2 0 0 0 2.1-13.4C53.7 12.4 54 11 54 11c-2.3.2-3.6.2-4.8.6A46.8 46.8 0 0 0 35.6 7h-1.4z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "dab_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dab_svg__a",
    overflow: "visible"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dab_svg__c",
    gradientUnits: "userSpaceOnUse",
    x1: -21.7,
    y1: 326.8,
    x2: -19.9,
    y2: 326.8,
    gradientTransform: "matrix(0 -25.9157 -25.9157 0 8510.3 -508.4)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a87c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00965f"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#dab_svg__b)",
    fill: "url(#dab_svg__c)",
    d: "M30.1 7H54v20.5H30.1z"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dab_svg__d",
    d: "M8.9 36.1c-.3 3.1-.5 5.3 0 7.8l-2.8.6v1.1l3.9 2.1c.9 2 1.9 3.4 3.4 4.9h.2l.1-.3c-.3-1.2-.7-2.2-.5-3.5 2 .6 3.8.9 6.1 1l.2-.4c-2-.8-4-1.4-5.7-2.9.5-1.4 1.1-2.6 2.1-4l.2-.4c-1.7.3-3.3.9-4.8 1.2-1.2-2.1-1.6-4.9-2.2-7.6l-.2.4z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "dab_svg__e"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dab_svg__d",
    overflow: "visible"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dab_svg__f",
    gradientUnits: "userSpaceOnUse",
    x1: -21.7,
    y1: 327.4,
    x2: -19.9,
    y2: 327.4,
    gradientTransform: "matrix(0 -25.9236 -25.9236 0 8499.6 -508.6)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a87c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00965f"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#dab_svg__e)",
    fill: "url(#dab_svg__f)",
    d: "M6.1 35.7h13.5v17H6.1z"
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dab_svg__g",
    d: "M24.6 19.1c-1.2.3-3.7 1.6-5.4 2.9l-3.5-.1c-1.7.1-4.2.2-5.6.6v.5c2 .1 4.6.7 5.6 1.7 0 0-2.7 2.4-5.6 7.7v.7c1.6-1.5 5.5-5 7.4-6 0 0 1.3 4.3 2.2 6.5l.2-.4c.2-1.4.9-5.2 1.9-7.5 0 0 .4-.2 2.2-.4 1.8-.2 4.4-.3 9.3.6l.2-.4c-1.1-.7-5.6-2.6-10.3-3.2h.2l1.4-3.3h-.2z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "dab_svg__h"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dab_svg__g",
    overflow: "visible"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dab_svg__i",
    gradientUnits: "userSpaceOnUse",
    x1: -21.7,
    y1: 327.1,
    x2: -19.9,
    y2: 327.1,
    gradientTransform: "matrix(0 -25.9078 -25.9078 0 8496.7 -508.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a87c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00965f"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#dab_svg__h)",
    fill: "url(#dab_svg__i)",
    d: "M10.2 19.1h23.5v14.6H10.2z"
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dab_svg__j",
    d: "M31.2 48.5 31 46c-1 1.3-1.8 2.4-2.9 3.6-1.2.3-2.5.3-3.7.3h-.9v.8c.9.4 1.8.7 2.8.9-.8.8-1.9 1.4-2.8 1.9v.5h.1c1.8-.5 4-1.2 5.6-2.2 1 0 1.9 0 2.6-.2l.2-.4c-.1-.4-.5-.7-.6-1.3 1.8-1.4 3-2.6 4.5-4.1l.2-.4c-1.4.9-3.2 2.3-4.9 3.1"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "dab_svg__k"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dab_svg__j",
    overflow: "visible"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dab_svg__l",
    gradientUnits: "userSpaceOnUse",
    x1: -21.7,
    y1: 327.1,
    x2: -19.9,
    y2: 327.1,
    gradientTransform: "matrix(0 -25.9153 -25.9153 0 8506.5 -508.4)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a87c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00965f"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#dab_svg__k)",
    fill: "url(#dab_svg__l)",
    d: "M23.5 45.3h12.7v8.6H23.5z"
  })), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dab_svg__m",
    d: "M.2.2h60.7v61.1H.2z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "dab_svg__n"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dab_svg__m",
    overflow: "visible"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dab_svg__o",
    gradientUnits: "userSpaceOnUse",
    x1: -35,
    y1: 321.1,
    x2: -33.2,
    y2: 321.1,
    gradientTransform: "matrix(0 35.638 35.638 0 -11412.9 1246.4)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00774a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8ac9ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00965f"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#dab_svg__n)",
    fill: "url(#dab_svg__o)",
    d: "M.2.2h60.7v61.1H.2z"
  })), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dab_svg__p",
    d: "M3.3 1.3c-.7.4-1.1 1.2-1.3 2.2l-.7 5.6V50l.7 7.2c.1 1 .6 1.8 1.3 2.2h55.1c.7-.4 1.2-1.1 1.2-2.2 0 0-.6-13.2-.6-26s.6-27.6.6-27.6c0-1-.5-1.8-1.3-2.2h-55z"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "dab_svg__q"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dab_svg__p",
    overflow: "visible"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dab_svg__r",
    gradientUnits: "userSpaceOnUse",
    x1: -34.5,
    y1: 321.4,
    x2: -32.7,
    y2: 321.4,
    gradientTransform: "matrix(0 40.0473 40.0473 0 -12842.2 1366.7)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00965f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8ac9ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00965f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#00774a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#008053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00986a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009e70"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#dab_svg__q)",
    fill: "url(#dab_svg__r)",
    d: "M1.3 1.3h58.3v58.1H1.3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.4 16.2c-3.8 2.2-5 2.4-9.1 4.9 2.4-2.6 3.2-3.7 4.7-5.9-3.8.2-9.3.7-13.3 1.5a54.8 54.8 0 0 1 13.9-4.4 44 44 0 0 0-9.3-5.5 39 39 0 0 1 15.1 4.4c1.2-.4 2.5-.4 4.9-.6-.6 1-.6 1.6-2.9 3.1a37 37 0 0 1-2.1 13.4c-.1-3.9-.5-8.8-1.9-10.9M19.6 49.5a15 15 0 0 1-5.5-3.4c.5-1.4 1.1-2.5 2.1-4l-4.6.8a24.4 24.4 0 0 1-2.4-7.2c-.3 3.1-.5 5.3 0 7.8-1.4.4-2.4.7-3.6 1.3 1.6 1 2.9 1.8 4.7 2.6 1 2.1 2 3.5 3.6 5.1a8.6 8.6 0 0 1-.3-3.9c2 .5 3.7.8 6 .9m5.7-30.9c-.7.9-1.5 2.5-1.7 3.3 5.6.8 10.1 3.7 10.1 3.7-4.9-.9-7.5-.8-9.3-.6-1.8.2-2.2.4-2.2.4-1.3 2.9-2.1 7.9-2.1 7.9-.9-2.2-2.2-6.5-2.2-6.5a62.6 62.6 0 0 0-8.2 6.7 31 31 0 0 1 6.3-9.1c-1.1-1.1-4-1.7-6.1-1.8a25.8 25.8 0 0 1 9.5-1 17 17 0 0 1 5.9-3m5.9 27c-1 1.3-1.8 2.4-3 3.6-1.8.6-3.3.8-5.2.8 1.1.6 2.2.9 3.4 1.2-1.2 1.1-2.2 1.8-3.3 2.6 1.9-.5 4.5-1.3 6.3-2.4 1 0 1.9 0 2.6-.2l-.4-1.7a36 36 0 0 0 4.5-4.1 36.4 36.4 0 0 1-4.7 2.8l-.2-2.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.8 9.5c.2 2.3.3 7.9.3 10 0 1.9 0 8.3-.3 11v.2h10c4.9 0 10.1-1.5 10.1-5.9 0-2.7-2-4.7-5.7-5.8 2.7-.7 4.5-2.6 4.5-4.8 0-3.5-4.1-4.9-7.9-5h-11v.3zm7.7 2.2c4.2 0 5.7.9 5.7 3.1 0 .6-.2 1.1-.6 1.6-.8 1-2.4 1.4-4.4 1.3h-.1l-1.1 3h1.2c2.3-.1 4.3.7 5.3 1.9.5.6.7 1.2.7 1.9 0 2.4-2.1 3.6-6.2 3.6h-2.5a420.4 420.4 0 0 1 0-16.4h2m-23.2-2.4-.1.1c-1.1 3-8.1 18.6-9.2 21l-.1.3h5v-.1c.4-1.5 1-3.1 1.7-4.9l4.1-.1h4.1a509 509 0 0 1 1.9 4.9v.1h5.8l-9.4-21.5h-3.8zm1.4 6.3 3 7.3h-3.1l-3.1-.1 3.2-7.2M84.6 9.3c9 0 12.5 4.8 12.5 10.7 0 6.1-3.4 10.8-12.8 10.8h-8c.3-2.9.3-6.8.3-11.2 0-2.1 0-7.4-.3-10.2h8.3zM82.1 12l-.1 7.5.1 8.5 1.5.1c5.2 0 7.9-1.6 7.9-8.2 0-6.3-2.8-8.1-8-7.9h-1.4zm-.7 28c2.7 0 3.7.6 3.7 2.1 0 .4-.1.7-.4 1-.5.6-1.6.9-2.9.9h-.1l-.8 2h.8c1.5 0 2.8.4 3.5 1.2.3.4.5.8.5 1.3 0 1.6-1.4 2.4-4.1 2.4H80v-5.8l.1-5 1.3-.1m-5-1.5.2 6.5c0 1.2 0 5.4-.2 7.2v.1h6.5c3.2 0 6.6-1 6.6-3.9 0-1.8-1.3-3.1-3.7-3.8 1.8-.5 3-1.7 3-3.1 0-2.3-2.7-3.2-5.2-3.3h-7.2v.3zm28.1-.1h-3.2l.1 3.5.2 5.3-1.3-2.2c0-.1-3.3-5.1-4.5-6.6h-3.7v.1l.2 6.6c0 1.2 0 5.4-.2 7.2v.1h3.3v-.1c-.2-3.4-.2-6.9-.2-10.3a628.7 628.7 0 0 1 6.8 10.3v.1h2.6v-.1c-.2-1.8-.2-6-.2-7.2l.2-6.6v-.1h-.1zm8.6 1.7c1.8 0 3.1.3 3.7 1.1.3.3.4.8.4 1.3 0 2-2.3 2.5-4.2 2.5h-1.1v-4.7c.4-.2.8-.2 1.2-.2m-4.8-1.6.2 6.6c0 1.2 0 5.4-.2 7.2v.1h3.9v-.1l-.2-5.7h1.3c5.2 0 7.7-1.4 7.7-4.2 0-3.3-3.5-4-6.5-4.1h-6.1l-.1.2zm24.9 1.6c1.8 0 3.1.3 3.7 1.1.3.3.4.8.4 1.3 0 2-2.3 2.5-4.2 2.5H132v-1.8l.1-2.9c.2-.2.7-.2 1.1-.2m-4.8-1.6.2 6.6c0 1.2 0 5.4-.2 7.2v.1h3.9v-.1l-.2-5.7h1.3c5.1 0 7.7-1.4 7.7-4.2 0-3.3-3.5-4-6.5-4.1h-6.1l-.1.2zm18.8 4 2 4.8h-4.1l2.1-4.8m-1-4.1c-.8 2.1-5.5 12.3-6.2 13.9l-.1.2h3.4v-.1l1.1-3.2h5.6l1.3 3.2v.1h3.9l-6.3-14.1h-2.7zm10.5.1.2 6.6c0 1.2 0 5.4-.2 7.2v.1h3.9v-.1c-.2-1.8-.2-6-.2-7.2l.1-4.9 1.1-.1c1.8 0 3.1.3 3.7 1.1.3.3.4.8.4 1.3 0 1.6-1.5 2.4-2.9 2.5h-1.1l.2.3c1.4 2 3.5 5.6 4.3 7.2v.1h4.2l-.1-.2-4.1-6-.1-.1c2.1-.6 3.2-1.9 3.2-3.7 0-3.3-3.5-4-6.5-4.1h-6.1zm19.2-.1h-3.8v.1l.2 6.6c0 1.2 0 5.4-.2 7.2v.1h3.9v-.1c-.2-1.8-.2-6-.2-7.2l.2-6.6v-.1h-.1zm8.7 1.6c2.7 0 3.7.6 3.7 2.1 0 .4-.1.7-.4 1-.5.6-1.6.9-2.8.9h-.1l-.7 2h.8c1.5 0 2.8.4 3.5 1.2.3.4.5.8.5 1.3 0 1.6-1.4 2.4-4 2.4h-1.7l-.1-5.7.1-5c.2-.2.7-.2 1.2-.2m-5-1.5.2 6.5c0 1.2 0 5.4-.2 7.2v.1h6.5c3.2 0 6.6-1 6.6-3.9 0-1.8-1.3-3.1-3.7-3.8 1.8-.5 3-1.7 3-3.1 0-2.3-2.7-3.2-5.2-3.3h-7.2v.3zm21 4 2 4.8h-4.1l2.1-4.8m1.7-4.1h-2.6v.1c-.8 2.1-5.7 12.9-6.1 13.8l-.1.2h3.4v-.1l1.1-3.2h5.6l1.2 3.2v.1h3.9l-6.4-14.1zm7.4 3.6c0 2.5 2.5 3.5 4.7 4.4 1.7.7 3.5 1.4 3.5 2.6 0 .4-.1.6-.3.9-.4.5-1.2.7-2.6.6-1.3-.1-2.8-.5-4.4-1.2l-.7-.3v3l.4.1.3.1c.8.2 2.4.6 4 .6 4.1 0 6.6-1.6 6.6-4.4 0-2.5-2.5-3.5-4.8-4.4-1.7-.7-3.4-1.3-3.4-2.4 0-.3 0-1.3 2.1-1.3 1.6 0 3.1.6 4 1l.8.3v-3.1l-.8-.1c-.8-.2-2.1-.4-3.5-.4-3.5-.1-5.9 1.6-5.9 4",
    style: {
      fill: "#1d1d1b"
    }
  }));
};

export default SvgDab;